import request from "@/utils/request";
import v1VideoListProd from "@/utils/v1_video_list_production";
import v1VideoListStaging from "@/utils/v1_video_list_staging";

export async function loadFromSlug(context, slug) {
  const finder = { path: slug, source: "slug" };
  return load(context, finder);
}

export async function loadFromPath(context, finder) {
  finder.source = "path";
  return load(context, finder);
}

export async function load(context, finder) {
  // Talvez seja interessante tratar erros no request com try/catch em algum momento.
  const response = await request({
    url: `/v2/brand_channel_discovery/${finder.source}`,
    method: "post",
    data: { finder }
  });
  window.__ovmSID = response.data.tape.session_id;
  context.commit("setTape", response.data.tape);

  if(response.data.tape.is_vue){
    const urlVue = window.location.origin + response.data.tape.path;
    window.location.href = urlVue;
  }

  if (
    !response.data.tape.is_vue &&
    !v1VideoListProd.includes(response.data.tape.video_id) &&
    !v1VideoListStaging.includes(response.data.tape.video_id)
  ) {
    return `/v2${response.data.tape.path}`;
  }

  return response.data.tape.path;
}
